<script setup lang="ts">
import { RouterLink } from "vue-router";

// The one-time "Cortex is now Velma" announcement, shown in <wa-page>'s `banner` slot above
// the header on every signed-in page.
//
// Deliberately not dismissible. A rename is not a preference: everyone needs to see it once,
// including the people who never read banners, and a dismissal record would let someone close
// it on day one and then wonder why their bookmarks say Cortex. Instead it expires on its
// own after a month, which also means no localStorage key to write, migrate or clean up
// later.
//
// The bar itself does not say WHY -- that lives on the About page behind the "Why?" link, so
// the reason (a name collision with a Darwinbox tool) isn't repeated to every user on every
// page. That makes the About note load-bearing: if it's ever trimmed, this link stops
// answering the question it poses.
const SHOW_UNTIL = new Date("2026-10-11T23:59:59");

// Read once at setup rather than as a computed: the cutoff cannot meaningfully elapse during a
// single session, and a stale banner disappears on the next page load.
const visible = Date.now() < SHOW_UNTIL.getTime();
</script>

<template>
  <div v-if="visible" class="rename-notice">
    <wa-icon name="circle-info"></wa-icon>
    <span><strong>Cortex is now called Velma!</strong> Nothing else has changed.</span>
    <RouterLink :to="{ name: 'about' }">Why?</RouterLink>
  </div>
</template>
